import React from "react";
import {
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  SelectProps,
  SxProps,
} from "@mui/material";

export interface LoadingSelectProps<T = string>
  extends Omit<SelectProps<T>, "label" | "labelId"> {
  label: string;
  labelId: string;
  loading?: boolean;
  formControlSx?: SxProps;
  labelSx?: SxProps;
  selectSx?: SxProps;
}

// 既存のUIに合わせて、セレクトとスピナーをまとめて扱う
export const LoadingSelect = <T,>({
  label,
  labelId,
  loading = false,
  formControlSx,
  labelSx,
  selectSx,
  children,
  ...selectProps
}: LoadingSelectProps<T>) => {
  return (
    <FormControl
      size="small"
      sx={{
        width: "100%",
        backgroundColor: "#404040",
        borderRadius: 1,
        position: "relative",
        ...formControlSx,
      }}
    >
      <InputLabel
        id={labelId}
        sx={{
          color: "#f0f0f0",
          fontSize: "12px",
          ...labelSx,
        }}
      >
        {label}
      </InputLabel>
      <Select
        labelId={labelId}
        label={label}
        size="small"
        sx={{
          color: "#f0f0f0",
          fontSize: "12px",
          ".MuiSvgIcon-root": {
            color: "#f0f0f0",
            display: loading ? "none" : "block",
          },
          ...selectSx,
        }}
        {...selectProps}
      >
        {children}
      </Select>
      {loading && (
        <CircularProgress
          size={16}
          sx={{
            color: "#f0f0f0",
            position: "absolute",
            right: 12,
            top: "50%",
            marginTop: "-8px",
            pointerEvents: "none",
          }}
        />
      )}
    </FormControl>
  );
};
